import { render, staticRenderFns } from "./UserStatus.vue?vue&type=template&id=4864e961&scoped=true"
import script from "./UserStatus.vue?vue&type=script&lang=js"
export * from "./UserStatus.vue?vue&type=script&lang=js"
import style0 from "./UserStatus.vue?vue&type=style&index=0&id=4864e961&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4864e961",
  null
  
)

export default component.exports